// extracted by mini-css-extract-plugin
module.exports = {"post":"DiscussionsPosts_post__zsohV","start-discussion":"DiscussionsPosts_start-discussion__uj36i"};